/** API client for AI model/prompt experimentation. */
import { apiGet, apiPost } from './client';
import {
  ExperimentResults,
  ExperimentRun,
  ExperimentRunSummary,
  ExperimentStatus,
  PromoteExperimentResponse,
  StartExperimentRequest,
  StartExperimentResponse,
} from '../types/experiment';

export function startExperiment(req: StartExperimentRequest): Promise<StartExperimentResponse> {
  return apiPost('/experiments', req);
}

export function listExperiments(): Promise<{ runs: ExperimentRunSummary[] }> {
  return apiGet('/experiments');
}

export function getExperiment(runId: string): Promise<ExperimentRun> {
  return apiGet(`/experiments/${runId}`);
}

export function getExperimentResults(runId: string): Promise<ExperimentResults> {
  return apiGet(`/experiments/${runId}/results`);
}

export function cancelExperiment(
  runId: string,
): Promise<{ runId: string; status: ExperimentStatus }> {
  return apiPost(`/experiments/${runId}/cancel`, {});
}

/**
 * Copy a run's config into the production AI config.
 *
 * Applies to newly ingested tickets only — existing summaries are not
 * regenerated by this call.
 */
export function promoteExperiment(runId: string): Promise<PromoteExperimentResponse> {
  return apiPost(`/experiments/${runId}/promote`, {});
}
